import { Segment } from '../../components/cohort/HowDoI/HowDoI';
import { SuperScript } from '../../components/cohort/SuperScript';

export const MaxBorrowingContent: Segment = {
  header: 'Max my borrowing power',
  imageUrl: '/next-assets/images/cohort/athena-maxborrowing-superpower.svg',
  imageAlt: "ATHENA'S MAX BORROWING SUPERPOWERS",
  gridContent: [
    {
      title: 'Investor friendly borrowing power',
      description:
        'Our extra friendly borrowing policy means investors can get the property they want, where they want, sooner.',
    },
    {
      title: 'Super fast, accurate pre-approval',
      description:
        'We get you bid ready in a flash. Your credit approved 90 day rate-locked pre-approval is done in days, not weeks.',
    },
    {
      title: 'The full Investor toolkit',
      description:
        'Couple your borrowing power with fast equity release, top-ups, split loans, multi-offsets, no fee options, cross-collateralisation and super sharp IO rates.',
    },
  ],
  quote: {
    author: 'Claudio, Athena Loan Expert',
    quote:
      '“Before coming to Athena, my customer was told he’d have to wait three more months before he could borrow the amount he wanted. We were able to get him pre-approved in two days and a few days later, he purchased a property!​”',
    isTrustPilot: false,
    avatarUrl: '/next-assets/images/cohort/how-do-i-le-4.png',
  },
};

export const ActNowContent: Segment = {
  header: 'Act now',
  imageUrl: '/next-assets/images/cohort/athena-actnow-superpower.svg',
  imageAlt: "ATHENA'S ACT NOW SUPERPOWERS",
  gridContent: [
    {
      title: 'Super fast, accurate pre-approval',
      description:
        "We get you a fully credit approved pre-approval in days, not weeks. It's locked in for 90 days and if rates change, your borrowing power won't.",
    },
    {
      title: 'Your Investor A-team',
      description:
        "Be armed with all the answers so you're ready to GO! Get quick-fire answers on SMS, chat or on the phone.",
    },
  ],
  quote: {
    author: 'Matthew, Athena Loan Expert',
    quote:
      '"My customer wanted to start looking at properties ASAP.  We sent through pre-approval in 24 hours so they could submit offers confidently."',
    isTrustPilot: false,
    avatarUrl: '/next-assets/images/cohort/how-do-i-le-5.png',
  },
};

export const MaxReturnsContent: Segment = {
  header: 'Max my returns',
  imageUrl: '/next-assets/images/cohort/athena-maxreturns-superpower.svg',
  imageAlt: "ATHENA'S MAX RETURNS SUPERPOWERS",
  gridContent: [
    {
      title: 'Unlock equity fast',
      description:
        'Boost your returns by giving your investment a facelift. We have extra friendly borrowing policy and generous, fast cash-out processes.',
    },
    {
      title: 'Drop your own rate',
      description: (
        <span>
          Save on interest when you drop your own rate as you pay down your loan with AcceleRATES
          <SuperScript>2</SuperScript>.
        </span>
      ),
    },
    {
      title: 'The full Investor toolkit',
      description:
        'Structure your portfolio your way with split loans, multi-offsets and cross-collateralisation. Leverage your assets to maximise your tax situation and grow your portfolio.',
    },
    {
      title: 'No fee loans. No loyalty tax',
      description: (
        <span>
          Super sharp “no-need-to-negotiate” investor rates, that stay great. New customers never get a better rate than
          existing customers on like-for-like loans
          <SuperScript>3</SuperScript>.
        </span>
      ),
    },
  ],
  quote: {
    author: 'Eric, Athena Loan Expert',
    quote:
      '“My customer was buying their first investment property and had been advised by their financial advisor to pick a home loan with an offset account to maximise their tax deductions. They went ahead with our Power Up loan which was perfect for their needs and investment goals.”',
    isTrustPilot: false,
    avatarUrl: '/next-assets/images/cohort/how-do-i-le-4.png',
  },
};

export const InvestorExpert: Segment = {
  header: 'Get an expert to do it for me',
  imageUrl: '/next-assets/images/cohort/athena-investorexpert-superpower.svg',
  imageAlt: "ATHENA'S INVESTOR EXPERT SUPERPOWERS",
  gridContent: [
    {
      title: 'Your dedicated Investor Experts',
      description: 'When you choose Athena, you get a dedicated Investor Expert who know you and your situation.',
    },
    {
      title: 'Fast answers how you want them',
      description:
        'Your dedicated team is at the ready with rapid response SMS or online chat. Phone and email available too.',
    },
    {
      title: 'Loan structuring to max your asset',
      description: 'Your Investor Experts can structure your loan for your strategy which means max returns.',
    },
  ],
  quote: {
    author: 'Janelle, Home Loan Wrecker',
    quote: '“Nothing was ever too much trouble and they are so proactive.”',
    isTrustPilot: true,
  },
};
